export const defaultValues = {
	nip: '',
	email: '',
	phoneNumber: '',
};

